import React from 'react';

import Modal from '../../../shared/Modal/Modal';

const ImageModal = ({ onClose, imageUrl, title, showModal }) => (
  <Modal show={showModal} onHide={onClose} size="lg" centered>
    <Modal.CustomHeader closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.CustomHeader>
    <Modal.Body>
      <img src={imageUrl} alt="Referral Program" className="w-full h-full object-contain rounded-lg" />
    </Modal.Body>
  </Modal>
);

export default ImageModal;
